import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { STATE__workspace } from '../STATE__workspace';

interface Payload {
  workspace_id: string;
  user_id: string;
}

export const LOCAL__workspace__set_current = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.WORKSPACE_SET_CURRENT,
  payload,
});

export function INIT_LOCAL__workspace__set_current(state: STATE__workspace, action: PayloadAction<Payload>) {
  let { user_id, workspace_id } = action.payload;

  if (workspace_id == state.workspace_current._id) return;

  let workspace = state.workspaces_map.get_or_assert(workspace_id, { context: 'workspace' });

  state.workspace_current = workspace;

  let users_map = state.all_workspaces_users_map.get_or_create_map(workspace_id);

  let user = users_map.get_value_or_default(user_id, DTO__workspace_user.CREATE_STUB({ user_id, workspace_id }));

  state.current_workspace_user = user;
}
